import $ from 'jquery'

module.exports = function() {
	module: {

	}

	return $.main
}

if (!window.location.origin) {
	window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}

window.main = {
	is_active_class : 'active',
	is_open_class   : 'is-opened',
	is_close_class  : 'is-closed',
	is_hover_class  : 'is-hover',
	is_focus_class  : 'is-focus',
	is_ajax_class   : 'is-ajax',
	in_trail_class  : 'in-trail',
	has_value_class : 'has-value',
	revalidate_class: 'revalidate',
	hover_is_open: false,
	graphql_server: window.location.origin + '/wp/graphql'
}